export default __webpack_public_path__ + "static/media/florafarms.a3c0eae3.jpg";